import json from './sprite.js';

export default {
    handle: 'ENG_SPT2-Kites_225002840',
    label: 'en_SPT2-Kites_225002840',
    json,
};
